import {
  Loading
} from 'element-ui';

export const accAdd = (arg1, arg2) => {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split('.')[1].length;

  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;

  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = (r1 >= r2) ? r1 : r2;
  return Number(((arg1 * m + arg2 * m) / m).toFixed(n));
}

export const accSub = (arg1, arg2) => {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2)); // last modify by deeka //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2;
  return Number(((arg1 * m - arg2 * m) / m).toFixed(n));
}
export const accMul = (arg1, arg2) => {
  let m = 0;
  let n = 0;
  let r1;
  let r2;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  n = r1 + r2;
  let s1 = arg1.toString();
  let s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return Number((Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)).toFixed(n));
}

export const accDiv = (arg1, arg2) => {
  let t1 = 0;
  let t2 = 0;
  let r1;
  let r2;
  try {
    t1 = arg1.toString().split('.')[1].length;
  } catch (e) {}
  try {
    t2 = arg2.toString().split('.')[1].length;
  } catch (e) {}
  r1 = Number(arg1.toString().replace('.', ''));
  r2 = Number(arg2.toString().replace('.', ''));
  return (r1 / r2) * Math.pow(10, t2 - t1);
}
export default class myUtils {

  /**
   * 验证后缀
   * @param {name} name 文件名 XXX.png
   * @param {array} arr 验证的格式['png', 'jpg', 'jpeg', 'bmp', 'gif']
   */
  static isAssetType(name, arr) {
    // 后缀获取
    let suffix = ''
    // 获取类型结果
    let result = false;
    try {
      let fileArr = name.split('.')
      suffix = fileArr[fileArr.length - 1]
      if (suffix != "") {
        suffix = suffix.toLocaleLowerCase();
        // 进行图片匹配
        result = arr.some(item => item === suffix);
      }
    } catch (err) {}
    return result
  }

  static math = {
    add() {
      let arg = Array.from(arguments)
      return arg.reduce((total, num) => accAdd(total, num))
    },
    subtract() {
      let arg = Array.from(arguments)
      return arg.reduce((total, num) => accSub(total, num))
    },
    multiply() {
      let arg = Array.from(arguments)
      return arg.reduce((total, num) => accMul(total, num))
    },
    divide() {
      let arg = Array.from(arguments)
      return arg.reduce((total, num) => accDiv(total, num))
    },
  }

  //限制两位小数
  static setFLoat(value, num) {
    var fin = 0;
    if (value != '') {
      if (value.indexOf('.') > -1) {
        fin = value.slice(0, value.indexOf('.') + (num + 1));
      } else {
        fin = value;
      }
    }
    return fin
  }

  // 生成随机数
  static getRandom() {
    return new Date().getTime() + "_" + getRandNum();
  }
  /**
   *
   * @param dateNow :Date类
   * @param intervalDays ：间隔天数
   * @param bolPastTime  ：Boolean,判断在参数date之前，还是之后，
   */
  static getDateRange(dateNow, intervalDays, bolPastTime) {
    let oneDayTime = 24 * 60 * 60 * 1000;
    let list = [];
    let lastDay;
    if (bolPastTime == true) {
      lastDay = new Date(dateNow.getTime() - intervalDays * oneDayTime);
      list.push(this.formateDate(lastDay));
      list.push(this.formateDate(dateNow));
    } else {
      lastDay = new Date(dateNow.getTime() + intervalDays * oneDayTime);
      list.push(this.formateDate(dateNow));
      list.push(this.formateDate(lastDay));
    }
    return list;
  }
  static formateDate(time) {
    let year = time.getFullYear()
    let month = time.getMonth() + 1
    let day = time.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + month + '-' + day + ''
  }

  /**
   *
   * @param dateNow :Date类
   * @param intervalDays ：间隔天数
   * @param bolPastTime  ：Boolean,判断在参数date之前，还是之后，
   */
  static getDateRangeMonth(dateNow, intervalDays, bolPastTime) {
    let oneDayTime = 24 * 60 * 60 * 1000;
    let list = [];
    let lastDay;
    if (bolPastTime == true) {
      lastDay = new Date(dateNow.getTime() - intervalDays * oneDayTime);
      list.push(this.formateDateMonth(lastDay));
      list.push(this.formateDateMonth(dateNow));
    } else {
      lastDay = new Date(dateNow.getTime() + intervalDays * oneDayTime);
      list.push(this.formateDateMonth(dateNow));
      list.push(this.formateDateMonth(lastDay));
    }
    return list;
  }
  static formateDateMonth(time) {
    let year = time.getFullYear()
    let month = time.getMonth() + 1
    let day = time.getDate()
    if (month < 10) {
      month = '0' + month
    }
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + month
  }

  /**
   * 时间格式转换
   * YYYY-mm-dd HH:MM表示2019-06-06 19:45
   * @param {date} date 时间
   * @param {string} fmt 转换格式
   */
  static dateFormat(fmt, date) {
    let ret;
    const opt = {
      "Y+": date.getFullYear().toString(), // 年
      "m+": (date.getMonth() + 1).toString(), // 月
      "d+": date.getDate().toString(), // 日
      "H+": date.getHours().toString(), // 时
      "M+": date.getMinutes().toString(), // 分
      "S+": date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
      }
    }
    return fmt;
  }

  /**
   * 日期对象转为日期字符串
   * @param date 需要格式化的日期对象
   * @param sFormat 输出格式,默认为yyyy-MM-dd                        年：y，月：M，日：d，时：h，分：m，秒：s
   * @example  dateFormat(new Date())                               "2017-02-28"
   * @example  dateFormat(new Date(),'yyyy-MM-dd')                  "2017-02-28"
   * @example  dateFormat(new Date(),'yyyy-MM-dd HH:mm:ss')         "2017-02-28 13:24:00"   ps:HH:24小时制
   * @example  dateFormat(new Date(),'yyyy-MM-dd hh:mm:ss')         "2017-02-28 01:24:00"   ps:hh:12小时制
   * @example  dateFormat(new Date(),'hh:mm')                       "09:24"
   * @example  dateFormat(new Date(),'yyyy-MM-ddTHH:mm:ss+08:00')   "2017-02-28T13:24:00+08:00"
   * @example  dateFormat(new Date('2017-02-28 13:24:00'),'yyyy-MM-ddTHH:mm:ss+08:00')   "2017-02-28T13:24:00+08:00"
   * @returns {string}
   */
  static _dateFormat(date, sFormat = 'yyyy-MM-dd') {
    const time = {
      Year: 0,
      TYear: '0',
      Month: 0,
      TMonth: '0',
      Day: 0,
      TDay: '0',
      Hour: 0,
      THour: '0',
      hour: 0,
      Thour: '0',
      Minute: 0,
      TMinute: '0',
      Second: 0,
      TSecond: '0',
      Millisecond: 0
    };
    time.Year = date.getFullYear();
    time.TYear = String(time.Year).substr(2);
    time.Month = date.getMonth() + 1;
    time.TMonth = time.Month < 10 ? '0' + time.Month : String(time.Month);
    time.Day = date.getDate();
    time.TDay = time.Day < 10 ? '0' + time.Day : String(time.Day);
    time.Hour = date.getHours();
    time.THour = time.Hour < 10 ? '0' + time.Hour : String(time.Hour);
    time.hour = time.Hour < 13 ? time.Hour : time.Hour - 12;
    time.Thour = time.hour < 10 ? '0' + time.hour : String(time.hour);
    time.Minute = date.getMinutes();
    time.TMinute = time.Minute < 10 ? '0' + time.Minute : String(time.Minute);
    time.Second = date.getSeconds();
    time.TSecond = time.Second < 10 ? '0' + time.Second : String(time.Second);
    time.Millisecond = date.getMilliseconds();

    return sFormat.replace(/yyyy/ig, String(time.Year))
      .replace(/yyy/ig, String(time.Year))
      .replace(/yy/ig, time.TYear)
      .replace(/y/ig, time.TYear)
      .replace(/MM/g, time.TMonth)
      .replace(/M/g, String(time.Month))
      .replace(/dd/ig, time.TDay)
      .replace(/d/ig, String(time.Day))
      .replace(/HH/g, time.THour)
      .replace(/H/g, String(time.Hour))
      .replace(/hh/g, time.Thour)
      .replace(/h/g, String(time.hour))
      .replace(/mm/g, time.TMinute)
      .replace(/m/g, String(time.Minute))
      .replace(/ss/ig, time.TSecond)
      .replace(/s/ig, String(time.Second))
      .replace(/fff/ig, String(time.Millisecond));
  }
  /**
   * 判断字符串是否为空
   */
  static isEmpty(str) {
    if (str == null || str.length === 0 || str === " ") {
      return true;
    } else {
      return false;
    }
  }

  static isEmptyZeor(str) {
    if (str === null || str === "" || str === undefined || str === false) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * 对象遍历赋值
   */
  static objCpoy(from, to) {
    Object.keys(to).forEach(key => {
      if (from[key] != null) {
        to[key] = from[key];
      }
    });
  }

  /**
   * 清空对象
   */
  static objClear(obj) {
    Object.keys(obj).forEach(key => {
      obj[key] = "";
    });
  }

  /**
   * null undefined 转字符串
   */
  static isNull(str, finStr) {
    if (str == null || str == undefined || str == "undefined" || str == "null") {
      return finStr;
    } else {
      return str;
    }
  }

  /**
   * 空字符串转下划线
   */
  static emptyToBlank(str) {
    if (str == null || str.length === 0 || str === " ") {
      return "--"
    }
    return str;
  }

  /**
   * 对象遍历赋值
   */
  static objCpoy(from, to) {
    Object.keys(to).forEach(key => {
      if (from[key] != null) {
        to[key] = from[key]
      }
    })
  }

  /**
   * 清空对象
   */
  static objClear(obj) {
    Object.keys(obj).forEach(key => {
      obj[key] = "";
    })
  }

  /**
   * null undefined 转字符串
   */
  static isNull(str, finStr) {
    ;
    if (str == null || str == undefined || str == "undefined" || str == "null") {
      return finStr;
    } else {
      return str;
    }
  }

  //value：表单的值、item：表单的DOM对象
  static realName(rule, value, callback) {
    if (!value) {
      callback(new Error("真实姓名不能为空"))
    } else {
      const reg = /^[a-zA-Z\u4e00-\u9fa5\\s·.]+$/;
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error("真实姓名应由中文或英文组成"))
      }
    }
  }

  //value：表单的值、item：表单的DOM对象
  static password(value) {
    if (value != "") {
      if (!new RegExp(/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,}$/).test(value)) {
        return '密码不能少于8位，且至少包含数字、字母、特殊字符任意两者的组合'
      }
    }
  }

  static username(rule, value, callback) {
    if (!value) {
      callback(new Error("手机号不能为空"))
    } else {
      const reg = /^(13|14|15|16|17|18|19)[0-9]{9}$/;
      if (reg.test(value)) {
        callback()

      } else {
        callback(new Error("手机号格式不正确"))
      }
    }
  }

  //判断座机号与手机号
  static clinicPhone(rule, value, callback) {
    if (value) {
      const reg = /^(13|14|15|16|17|18|19)[0-9]{9}$/;
      const rr = /^[0][1-9]{2,3}-[0-9]{5,10}$/
      if (reg.test(value) || rr.test(value)) {
        callback()
      } else {
        callback(new Error("请输入正确的手机号或座机号"))
      }
    } else {
      callback()
    }
  }

  //判断身份证号
  static idCard(rule, value, callback) {
    if (value) {
      const reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error("身份证号格式不正确"))
      }
    } else {
      callback()
    }
  }

  /**
   * 判断是否为身份证号
   */
  static isIdCard(str) {
    return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(str);
  }

  /**
   * 检查手机号是否合法
   */
  static isRightPhone(str) {
    return /^1([3|4|5|7|8])\d{9}$/.test(str);
  }

  static tableHeight(data) {
    data.$nextTick(() => {
      data.height = document.body.offsetHeight - data.$refs.table.$el.offsetTop - 135
      window.onresize = () => {
        data.height = document.body.offsetHeight - data.$refs.table.$el.offsetTop - 135
      }
    })
  }

  static pageTableHeight(data, gapHeight = 0) {
    data.$nextTick(() => {
      data.height = document.body.offsetHeight - data.$refs.table.$el.offsetTop - 182 - gapHeight;
      data.$refs.table.doLayout();
      window.onresize = () => {
        data.height = document.body.offsetHeight - data.$refs.table.$el.offsetTop - 182 - gapHeight;
        data.$refs.table.doLayout();
      }
    })
  }

  static archiveTableHeight(data) {
    data.$nextTick(() => {
      data.height = document.body.offsetHeight - data.$refs.table.$el.offsetTop - 185
      data.treeheight = document.body.offsetHeight - data.$refs.tree.$el.offsetTop - 125
      window.onresize = () => {
        data.height = document.body.offsetHeight - data.$refs.table.$el.offsetTop - 185
        data.treeheight = document.body.offsetHeight - data.$refs.tree.$el.offsetTop - 125
      }
    })
  }

  static archiveTreeHeight(data) {
    // data.$nextTick(() => {
    //   // data.treeheight=document.documentElement.clientHeight
    //   data.treeheight = document.body.offsetHeight - data.$refs.tree.$el.offsetTop-125
    //   window.onresize = () => {
    //   //   data.treeheight=document.documentElement.clientHeight
    //     data.treeheight = document.body.offsetHeight - data.$refs.tree.$el.offsetTop -125
    //   }
    // })
  }

  static queryState(name) {
    if (name.length == 0) {
      return '暂无数据'
    } else {
      return '正在加载'
    }
  }

  static emptyA(cellValue) {
    if (!cellValue || cellValue == null) {
      return "--"
    }
    return cellValue
  }

  static globalLoading() {
    var loading = Loading.service({
      lock: true,
      text: '加载中,请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    return loading
  }
  //图片加载成功后返回url
  static loadImg(url) {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.src = url
      img.onload = () => {
        const obj = {
          width: img.width,
          height: img.height
        }
        resolve(url)
      }
      img.onerror = reject
    })
  }

}



// WEBPACK FOOTER //
// ./src/util/myUtils.js